var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-per-person-dropdown"},[_c('div',{staticClass:"price-per-person-dropdown__label"},[_vm._v("Cena za osobę")]),_vm._v(" "),_c('RadioList',{ref:"list",staticClass:"price-per-person-dropdown__body",attrs:{"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', _vm.selected)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d4e86a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/fields/PricePerPersonDropdown.vue
// module id = 843
// module chunks = 1